import './CountrySelector.scss';

import { Segmented } from 'antd';

import { useCountryContext } from '@/contexts/CountryContext';

/**
 * Flag de api only_br:
 * - false: muestra datos de todos los países menos Brasil.
 * - true: muestra solo datos de Brasil.
 */
const ARGENTINA_COUNTRY_ID = 0;
const BRASIL_COUNTRY_ID = 1;
const CountrySelector = () => {
  const { selectedCountryId, setSelectedCountryId } = useCountryContext();

  return (
    <Segmented
      className="CountrySelector"
      value={selectedCountryId === BRASIL_COUNTRY_ID ? BRASIL_COUNTRY_ID : ARGENTINA_COUNTRY_ID}
      onChange={countryId => setSelectedCountryId(Number(countryId))}
      options={[
        {
          label: <span className="CountrySelectorOption CountrySelectorOptionArgentina">AR</span>,
          value: ARGENTINA_COUNTRY_ID,
        },
        {
          label: <span className="CountrySelectorOption CountrySelectorOptionBrasil">BR</span>,
          value: BRASIL_COUNTRY_ID,
        },
      ]}
      size="small"
    />
  );
};

export default CountrySelector;
